import { handleResponse, handleError } from "./apiUtils";
import * as apiConfig from "./config";
const baseUrl = `${apiConfig.API_URL}admin/`;

export function getDashboardData() {
    return fetch(`${baseUrl}getdashboarddata`, { method: "GET", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getUserData(criteria) {
    return fetch(`${baseUrl}getusersummaries`, { method: "POST", body: JSON.stringify(criteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getGroupData(criteria) {
    return fetch(`${baseUrl}getgroupsummaries`, { method: "POST", body: JSON.stringify(criteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getErrorData(criteria) {
    return fetch(`${baseUrl}geterrors`, { method: "POST", body: JSON.stringify(criteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getRouteUploads(criteria) {
    return fetch(`${baseUrl}getrouteuploads`, { method: "POST", body: JSON.stringify(criteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function getRouteDownloads(criteria) {
    return fetch(`${baseUrl}getroutedownloads`, { method: "POST", body: JSON.stringify(criteria), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}



// WEBPACK FOOTER //
// ./src/api/adminApi.js